import { useEffect, useRef } from 'react';

import { uniq } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { doGetQuoteList } from 'src/actions';
import { QuoteConstant } from 'src/constants';

import { useAccountSelector } from './useAccountSelector';
import { usePositionListSelector } from './usePositionListSelector';

export const useRefreshQuoteMedia = () => {
  const dispatch = useDispatch();
  const { tradablePositionList } = usePositionListSelector();
  const isLoadingQuoteMedia = useSelector((state: any) => Boolean(state.quotes.list.isLoading));
  const timer = useRef<null | ReturnType<typeof setInterval>>(null);
  const { account } = useAccountSelector();

  const clearTimerIfExists = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
  };

  const refresh = () => {
    const tradableSymbols = tradablePositionList.map(aPosition => aPosition.symbol);

    clearTimerIfExists();

    timer.current = setInterval(() => {
      if (tradableSymbols.length && !isLoadingQuoteMedia) {
        dispatch(doGetQuoteList({ queryParams: { symbols: uniq(tradableSymbols).join(',') } }));
      }
    }, QuoteConstant.REFRESH_INTERVAL);
  };

  useEffect(() => {
    if (account?.accountId) {
      refresh();
    }

    return clearTimerIfExists;
  }, [tradablePositionList, account?.accountId, dispatch]);
};
